{% block acris_faq_group_list %}

    <sw-page class="acris-faq-group-list">
        {% block acris_faq_group_list_search_bar %}
            <template #search-bar>
                <sw-search-bar initialSearchType="FAQ group"
                               :placeholder="$tc('acris-faq-group.general.placeholderSearchBar')"
                               :initialSearch="term"
                               @search="onSearch">
                </sw-search-bar>
            </template>
        {% endblock %}

        {% block acris_faq_group_list_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_faq_group_list_smart_bar_header_title %}
                    <h2>
                        {% block acris_faq_group_list_smart_bar_header_title_text %}
                            {{ $tc('acris-faq-group.list.textHeadline') }}
                        {% endblock %}

                        {% block acris_faq_group_list_smart_bar_header_amount %}
                            <span v-if="!isLoading" class="sw-page__smart-bar-amount">
                        ({{ total }})
                        </span>
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_group_list_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_faq_group_list_smart_bar_actions_add %}
                    <mt-button variant="primary" @click="$router.push({ name: 'acris.faq.group.create' })" size="default">
                        {{ $tc('acris-faq-group.list.buttonAdd') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_group_list_cardview %}
            <template #content>
                <div class="acris-faq-group-list__content">
                    {% block acris_faq_group_list_content %}
                        <sw-entity-listing class="acris-faq-group-list-grid"
                                           v-if="items && total > 0"
                                           :items="items"
                                           :repository="entityRepository"
                                           detailRoute="acris.faq.group.detail"
                                           :showSeleciton="true"
                                           :isLoading="isLoading"
                                           :columns="columns">

                            {% block acris_faq_group_list_grid_actions %}
                            <template #more-actions="{ item }">
                                <sw-context-menu-item @click="onDuplicate(item.id)">
                                    {{ $tc('acris-faq-group.list.duplicateButton') }}
                                </sw-context-menu-item>
                            </template>
                            {% endblock %}

                            <template #pagination>
                                {% block sw_order_list_grid_pagination %}
                                    <sw-pagination :page="page"
                                                   :limit="limit"
                                                   :total="total"
                                                   :total-visible="7"
                                                   @page-change="onPageChange">
                                    </sw-pagination>
                                {% endblock %}
                            </template>

                        </sw-entity-listing>
                    {% endblock %}

                    {% block acris_faq_group_list_empty_state %}
                        <sw-empty-state v-if="!isLoading && total <= 0"
                                        :title="$tc('acris-faq-group.list.contentEmpty')"></sw-empty-state>
                    {% endblock %}

                </div>
            </template>
        {% endblock %}

        {% block acris_faq_group_list_sidebar %}
            <template #sidebar>
                <sw-sidebar class="acris-faq-group-list__sidebar">
                    {% block acris_faq_group_list_sidebar_item %}
                        <sw-sidebar-item
                            icon="regular-undo"
                            :title="$tc('acris-faq-group.list.titleSidebarItemRefresh')"
                            @click="onRefresh">
                        </sw-sidebar-item>
                    {% endblock %}
                </sw-sidebar>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
